import { useEffect, useState } from "react";

// Loads a list once and returns it (empty array while loading or on failure).
export const useAsyncList = (loader) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let alive = true;
    loader()
      .then((data) => alive && setItems(data || []))
      .catch(() => {});
    return () => {
      alive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return items;
};
